var _rect, _path, _rect2, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThumbnail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 76,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    x: 8,
    y: 10,
    fill: "#fff",
    rx: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#CC3D00",
    strokeLinecap: "round",
    d: "m34.994 28.902-9.941-10.07a1.154 1.154 0 0 0-1.643 0L16.8 25.53a1.154 1.154 0 0 0 0 1.621l9.845 9.974M26.907 20.762l-7.934 8.04"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 10.689,
    height: 42.74,
    x: -0.025,
    y: 0.711,
    fill: "#FFEEE5",
    stroke: "#CC3D00",
    rx: 0.654,
    transform: "matrix(.67723 .73577 -.7269 .68675 48.591 19.602)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#CC3D00",
    strokeLinecap: "round",
    d: "m37.266 30.604 3.055 3.095M32.34 34.895l4.88 4.944M28.496 38.99l3.894 3.943M46.205 39.065l6.622 6.71c.214.217.333.508.333.812V53.5c0 .638-.517 1.154-1.154 1.154h-6.284c-.309 0-.605-.123-.822-.343l-6.771-6.86"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbnail);
export default __webpack_public_path__ + "static/media/thumbnail.a7d7cde44fad9a0d4d490def43560a78.svg";
export { ForwardRef as ReactComponent };